/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Patient } from '../../models/patient';
import { SamlLoginRespose } from '../../models/saml-login-respose';

export interface SsoSetPatientContext$Params {
      body: SamlLoginRespose
}

export function ssoSetPatientContext(http: HttpClient, rootUrl: string, params: SsoSetPatientContext$Params, context?: HttpContext): Observable<StrictHttpResponse<Patient>> {
  const rb = new RequestBuilder(rootUrl, ssoSetPatientContext.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Patient>;
    })
  );
}

ssoSetPatientContext.PATH = '/SSO/saml/setPatientContext';
